export default __webpack_public_path__ + "static/media/cont4.a7ff347d.png";